const hour = new Date().getHours();

const greeting = `<p>Good ${hour >= 12 ? "afternoon" : "morning"},</p>
<p>I hope you’re well.</p>`;

const emailSignature = `<div>
<br/>
<p>
Kind Regards,<br />
The Recruitment team
<p/>
  <p >
  <img
    src="https://firebasestorage.googleapis.com/v0/b/rosemount-financial-solu-4f940.appspot.com/o/Website%2FAssets%2FEnquiries%20email%20signature.png?alt=media&token=be53ace5-1113-4300-95fd-5f0034fd8355"
    alt="Rosemount Financial Solutions (IFA) Ltd"
    width="auto"
    height="auto"
  />
  </p>
  <strong style="color: #081e56;">Tel: 01256 405460</strong>
  <br>
  <strong style="color: #081e56;">
    <a href="https://rosemountfs-ifa.co.uk/" style="color: #081e56;">
      Rosemount Financial Solutions (IFA) Ltd
    </a>
  </strong>
  </br >
  <br />
  <strong style="color: #081e56;">
  Rosemount House, 2-4 Chequers Road, Basingstoke, RG21 7PU
  </strong>
  <br />
  <p>
  Rosemount Financial Solutions (IFA) Ltd is authorised and regulated by
  Financial Conduct Authority (535515)
  <p />
  Registered in England and Wales, Registered No. 05668905, Registered Address
  Rosemount House, 2 – 4 Chequers Road, Basingstoke, RG21 7PU.
  <p />
  DISCLAIMER:
  <br />
  This message and any attachment are confidential and may be privileged or
  otherwise protected from disclosure. If you have received it in error, please
  telephone or email the sender and delete this message and any attachment from
  your system. If you have received it in error you must not copy this message
  or attachment or disclose the contents to any other person. Any views or
  opinions expressed in this email are those of the author only.
  <p />
  Email communications are not secure. For this reason Rosemount Financial
  Solutions (IFA) Ltd cannot guarantee the security of the email or its contents
  or that it will remain virus free once sent.   Please note that email passing
  through the servers of Rosemount Financial Solutions (IFA) Ltd may at any
  point be monitored or intercepted as part of the company's internal security
  policy. Thank you for your co-operation.
  <p />
</div>
`;


exports.emailSignature = emailSignature;
exports.greeting = greeting;